module.exports = __webpack_public_path__ + "img/Check_Circle_20px_Icon_red.d27c4448.svg";